import {Payload} from '../../../../../../../core/service/payload/payload';
import {MedicalRecordPainIntensityCreateUpdatePayload} from './medicalRecordPainIntensityCreateUpdate.payload';
import {CustomDatePayload} from '../../../../../../../common/custom-date/entity/payload/custom-date.payload';

export class MedicalRecordPainCreateUpdatePayload implements Payload{

    partnerId: number;
    consultationId: number;

    locations: string[] = [];
    locationComment: string;

    whens: string[] = [];
    whenComment: string;

    hows: string[] = [];
    howComment: string;

    from: CustomDatePayload;
    to: CustomDatePayload;

    comment: string;
    initialIntensity: MedicalRecordPainIntensityCreateUpdatePayload;

}
